import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import EmployeeReportsToTable from "./view/EmployeeReportsToTable";

interface EmployeeReportsToProps {}
export const EmployeeReportsTo: React.FC<EmployeeReportsToProps> = () => {
  const viewPermission = PERMISSIONS.permission_utilites_employeeReportsTo_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {" "}
      {userPermissions.includes(viewPermission) && (
        <EmployeeReportsToTable />
      )}{" "}
    </>
  );
};
export default EmployeeReportsTo;
